import { render, staticRenderFns } from "./HealthTable.vue?vue&type=template&id=29ef4a1b&scoped=true&lang=pug&"
import script from "./HealthTable.vue?vue&type=script&lang=js&"
export * from "./HealthTable.vue?vue&type=script&lang=js&"
import style0 from "./HealthTable.vue?vue&type=style&index=0&id=29ef4a1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29ef4a1b",
  null
  
)

export default component.exports